import { Layout } from "antd";
import { AN_COLORS, AN_FONT, AN_MONO } from "../design-system/tokens";

const { Footer } = Layout;

function AppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <Footer
      style={{
        padding: "12px 24px",
        background: "var(--an-surface)",
        borderTop: `1px solid ${AN_COLORS.line}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: 12,
        color: AN_COLORS.muted,
        fontFamily: AN_FONT,
        flexShrink: 0,
        position: "sticky",
        bottom: 0,
        lineHeight: 1.4,
      }}
    >
      <span>© {currentYear} AuthNull. All rights reserved.</span>
      <div style={{ display: "flex", gap: 18, alignItems: "center" }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            fontFamily: AN_MONO,
            fontSize: 11,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: AN_COLORS.success,
            }}
          />
          All systems operational
        </span>
      </div>
    </Footer>
  );
}

export default AppFooter;
